module.exports = __webpack_public_path__ + "img/jy.a10a4e7a.png";